// Enhanced CurrencyPicker class for Shopify
class CurrencyPicker extends HTMLElement {
    constructor() {
        super();
        this.initializePopup();
        this.bindEvents();
    }

    initializePopup() {
        // Create the popup HTML structure
        const popupHTML = `
            <div class="currency-popup-overlay" id="currencyPopup">
                <div class="currency-popup">
                    <div class="popup-header">
                        <h2 class="popup-title">CHOOSE YOUR LOCATION</h2>
                        <p class="popup-subtitle">Set your location for localised pricing,<br>currency and delivery options.</p>
                        <button class="popup-close">×</button>
                    </div>
                    
                    <div class="currency-list">
                        <a href="//musclenation.org${window.location.pathname}?country=au" class="currency-option" data-currency="AUD" data-country="AU">
                            <div class="flag-icon">
                                <img src="https://cdn.shopify.com/static/images/flags/au.svg" alt="Australia Flag" width="48" height="48" loading="lazy">
                            </div>
                            <div class="currency-info">
                                <div class="country-name">Australia</div>
                                <div class="currency-code">AUD</div>
                            </div>
                        </a>

                        <a href="//musclenation.org${window.location.pathname}?country=nz" class="currency-option" data-currency="NZD" data-country="NZ">
                            <div class="flag-icon">
                                <img src="https://cdn.shopify.com/static/images/flags/nz.svg" alt="New Zealand Flag" width="48" height="48" loading="lazy">
                            </div>
                            <div class="currency-info">
                                <div class="country-name">New Zealand</div>
                                <div class="currency-code">NZD</div>
                            </div>
                        </a>

                        <a href="//musclenation.us${window.location.pathname}?country=us" class="currency-option" data-currency="USD" data-country="US">
                            <div class="flag-icon">
                                <img src="https://cdn.shopify.com/static/images/flags/us.svg" alt="United States Flag" width="48" height="48" loading="lazy">
                            </div>
                            <div class="currency-info">
                                <div class="country-name">United States</div>
                                <div class="currency-code">USD</div>
                            </div>
                        </a>

                        <a href="//musclenation.org${window.location.pathname}?country=ca" class="currency-option" data-currency="CAD" data-country="CA">
                            
                            <div class="flag-icon">
                                <img src="https://cdn.shopify.com/static/images/flags/ca.svg" alt="Canada Flag" width="48" height="48" loading="lazy">
                            </div>
                            <div class="currency-info">
                                <div class="country-name">Canada</div>
                                <div class="currency-code">CAD</div>
                            </div>
                        </a>

                        <a href="//musclenation.org${window.location.pathname}?country=gb" class="currency-option" data-currency="GBP" data-country="GB">
                            <div class="flag-icon">
                                <img src="https://cdn.shopify.com/static/images/flags/gb.svg" alt="United Kingdom Flag" width="48" height="48" loading="lazy">
                            </div>
                            <div class="currency-info">
                                <div class="country-name">United Kingdom</div>
                                <div class="currency-code">GBP</div>
                            </div>
                        </a>

                        <a href="//musclenation.org${window.location.pathname}?country=fr" class="currency-option" data-currency="FR" data-country="FR">
                            <div class="flag-icon">
                                <img src="https://cdn.shopify.com/static/images/flags/eu.svg" alt="European Union Flag" width="48" height="48" loading="lazy">
                            </div>
                            <div class="currency-info">
                                <div class="country-name">European Union</div>
                                <div class="currency-code">EUR</div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        `;

        // Add popup to body if it doesn't exist
        if (!document.getElementById('currencyPopup')) {
            document.body.insertAdjacentHTML('beforeend', popupHTML);
        }

        this.popup = document.getElementById('currencyPopup');
    }

    bindEvents() {
        const localCurrency = window.localStorage.getItem("activeCurrency");
        const localizationForm = document.querySelector('localization-form');
        this.currency = localCurrency || window.default_currency;

        // Bind currency option clicks
        this.popup.querySelectorAll(".currency-option").forEach((element) => {
            element.addEventListener("click", (e) => {
                // e.preventDefault();
                const currency = element.dataset.currency;
                const country = element.dataset.country;
                
                this.setCurrency(currency);
                
                if (localizationForm) {
                    localizationForm.querySelector('[name=country_code]').value = country;
                    localizationForm.querySelector('form').submit();
                }
                
                this.closePopup();
            });
        });

        // Close popup events
        this.popup.querySelector('.popup-close').addEventListener('click', () => {
            this.closePopup();
        });

        this.popup.addEventListener('click', (e) => {
            if (e.target === this.popup) {
                this.closePopup();
            }
        });

        // ESC key to close
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.popup.classList.contains('active')) {
                this.closePopup();
            }
        });

        // Listen for currency changes
        window.addEventListener("currency_changed", (event) => {
            this.currency = event.detail.currency;
            this.render();
        });

        this.render();
    }

    setCurrency(currency) {
        window.localStorage.setItem("activeCurrency", currency);
        window.dispatchEvent(
            new CustomEvent("currency_changed", {
                detail: { currency }
            })
        );
    }

    openPopup() {
        this.popup.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    closePopup() {
        this.popup.classList.remove('active');
        document.body.style.overflow = '';
    }

    render() {
        // Update any active currency displays
        const activeCurrencyElement = this.querySelector(".active-currency");
        if (activeCurrencyElement) {
            const currencyButton = this.querySelector(`[data-currency='${this.currency}']`);
            if (currencyButton) {
                activeCurrencyElement.innerHTML = currencyButton.innerHTML;
            }
        }
    }
}

// Register the custom element
customElements.define("currency-picker", CurrencyPicker);

// Global functions for demo
function openCurrencyPopup() {
    const currencyPicker = document.querySelector('currency-picker') || new CurrencyPicker();
    currencyPicker.openPopup();
}

function closeCurrencyPopup() {
    const currencyPicker = document.querySelector('currency-picker') || new CurrencyPicker();
    currencyPicker.closePopup();
}

// Auto-initialize if currency-picker element exists
document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('currency-picker')) {
        new CurrencyPicker();
    }
});